import { constants } from "@src/game/Constants";

type TGameEventKeys =
  | (typeof constants.GameEvents)[keyof typeof constants.GameEvents]
  | (typeof constants.UIEvents)[keyof typeof constants.UIEvents];

export class EventSystem {
  private static _listeners: Record<TGameEventKeys, Function[]> = {} as Record<
    TGameEventKeys,
    Function[]
  >;

  private constructor() {}

  public static addListener(event: TGameEventKeys, callback: Function): void {
    if (!this._listeners[event]) {
      this._listeners[event] = [];
    }
    this._listeners[event].push(callback);
  }

  public static removeListener(
    event: TGameEventKeys,
    callback: Function,
  ): void {
    if (!this._listeners[event]) return;

    const index = this._listeners[event].indexOf(callback);
    if (index > -1) {
      this._listeners[event].splice(index, 1);
    }
  }

  public static invoke(event: TGameEventKeys, ...args: any[]): void {
    if (!this._listeners[event]) return;

    this._listeners[event].forEach((callback) => {
      callback(...args);
    });
  }
}
